module.exports = __webpack_public_path__ + "static/media/huawei_app_launch_3.840ae649.png";